'use strict';

angular.module('app.influencerGroupInfluencerList')
    .controller('influencerGroupInfluencerListCtrl', ['$scope', '$rootScope', '$compile', 'adminService', 'influencerGroupInfluencerListService', '$location', '$state',
        function ($scope, $rootScope, $compile, adminService, influencerGroupInfluencerListService, $location, $state) {

        $scope.slick_config = {
            autoplay: false,
            infinite: false,
            draggable: true,
            arrows: false,
            autoplaySpeed: 1000,
            slidesToShow: 7,
            slidesToScroll: 7,
            method: {},
            event: {
                afterChange: function (event, slick, currentSlide, nextSlide) {
                    if(currentSlide == $scope.influencers.length - 7 && !$scope.loading){
                        if($scope.influencers.length == ($scope.offset + $scope.limit)) {
                            $scope.influencersTag = event.currentTarget.id;
                            $scope.influencerGroupId = $scope.influencersTag.split('-')[2];
                            $scope.loading = true;
                            $scope.offset = $scope.offset + $scope.limit; 
                            
                            getInfluencerInfluencerList($scope.influencerGroupId, $scope.limit, $scope.offset, false);
                        }
                    }
                }
            }
        };

        var linkNoImage = "/images/default_influencer_profile_image_150.png";
        $scope.influencersTag = "";
        $scope.influencers = [];
        $scope.loading = false;
        $scope.limit = 14;
        $scope.offset = 0;

        function getInfluencerInfluencerList(influencer_group_id, limit, offset, loader) {
            influencerGroupInfluencerListService.getInfluencerGroupInfluencers(influencer_group_id, limit, offset, loader)
                .then(function(responseGetInfluencerGroupInfluencers) {
                    angular.forEach(responseGetInfluencerGroupInfluencers.influencers, function(influencer) {
                        $scope.influencers.push(influencer);

                        var index = $scope.influencers.length - 1;
                        if($scope.influencers[index].influencer_image == null) {
                            $scope.influencers[index].influencer_image = linkNoImage;
                        }

                        $scope.influencers[index].default_image = linkNoImage;

                        var platform_html = '';
                        angular.forEach($scope.influencers[index].influencer_platforms, function(platform) {
                            platform_html = platform_html + '<div style="float: left; margin-right: 4px;">' +
                                                                '<img width="18" height="18" ng-src="{{PlatformIcon(' + platform.platform_id + ')}}">' +
                                                            '</div>';
                        })

                        var html = '<div class="influencer-image">' +
                                    '<div class="image" ng-click="influencerOverviewPage(influencers[' + index + '].influencer_id)" ng-attr-style="background-image: url(\'{{influencers[' + index + '].influencer_image}}\'), url(\'{{influencers[' + index + '].default_image}}\')" ' +
                                            'data-toggle="popover" ' +
                                            'data-placement="left" ' +
                                            'data-html="true" ' +
                                            'data-container="body" ' +
                                            'data-trigger="hover" ' +
                                            'data-content-compile=\'<div style="width: 212px; height: auto; overflow: auto;">' +
                                                                    '<div class="col-xs-12" style="padding:0px;">' +
                                                                          '<div class="col-xs-2" style="padding:0px;">' +
                                                                              '<img data-container="body" ng-src="{{influencers[' + index + '].influencer_image}}" style="width: 32px; height: 32px; margin: 8px 0px 0px 8px;" onerror="onImageError(this)">' +
                                                                          '</div>' +
                                                                          '<div class="col-xs-10">' +
                                                                              '<div class="col-xs-12" style="font-size: 14px; font-family: ProximaNovaRegular; color: #4c5667; line-height: 1.429; padding: 0px; margin: 8px 0px 0px -5px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{influencers[' + index + '].influencer_name}}</div>' +
                                                                              '<div class="col-xs-12" style="font-size: 11px; font-family: ProximaNovaRegular; color: #4c5667; line-height: 1.818; padding: 0px; margin: -5px 0px 0px -5px;">{{influencers[' + index + '].influencer_country}}</div>' +
                                                                          '</div>' +
                                                                      '</div>' +
                                                                     ' <div class="col-xs-12" style="padding: 4px 0px 0px 8px;">' +
                                                                            platform_html +
                                                                      '</div>' +
                                                                      '<div class="col-xs-12" style="padding: 18px 0px 0px 8px;">' +
                                                                          '<div class="col-xs-1" style="padding:0px;">' +
                                                                              '<img width="17" height="17" src="/images/people32.png">' +
                                                                          '</div>' +
                                                                          '<div class="col-xs-5" style="font-size: 13px; font-family: ProximaNovaSemibold; color: #4c5667; padding:4px 0px 0px 7px;">{{influencers[' + index + '].reach | number: 0}}</div>' +
                                                                          '<div class="col-xs-1" style="padding:0px;">' +
                                                                              '<img width="17" height="17" src="/images/conversion32.png">' +
                                                                          '</div>' +
                                                                          '<div class="col-xs-5" style="font-size: 13px; font-family: ProximaNovaSemibold; color: #4c5667; padding:4px 0px 0px 6px;">{{influencers[' + index + '].engagement | number: 0}}</div>' +
                                                                      '</div>' +
                                                                  '</div>\' ' +
                                            'influencer-info-popover></div>' +
                                    '</div>';

                        var influencer_html = $compile(html)($scope);
                        console.log($('#influencer-list-' + influencer_group_id));
                        $('#influencer-list-' + influencer_group_id).slick('slickAdd', influencer_html);
                    });
                    $scope.loading = false;
                })
        }

        $scope.PlatformIcon = function (platform_id) {
            return adminService.getPlatformIcon(platform_id);
        }

        getInfluencerInfluencerList($scope.influencerGroupId, $scope.limit, $scope.offset, false);

        $scope.influencerOverviewPage = function(influencer_id){
            $("[rel=popover]").popover("destroy");
            $(".popover").remove();
            $rootScope.previousPage = $location.absUrl();
            $state.transitionTo('home.influencerOverview', {influencer_id: influencer_id}, {
                reload: false,
                inherit: true,
                notify: true
            });
        }
            
    }])

    var onImageError = function (element){
        element.src = '/images/default_influencer_profile_image_150.png';
    };